<template>
  <el-dialog
    class="dialog-container"
    title="适用国家"
    :visible.sync="dialogVisible"
    append-to-body
    width="600px"
  >
    <el-tree
      ref="countryTree"
      :data="treeData"
      show-checkbox
      node-key="countryId"
      :props="defaultProps"
      :filter-node-method="filterNode"
      :default-checked-keys="checkedCountryIds"
      :default-expanded-keys="expandedKeys"
      v-loading="loading"
    >
    </el-tree>
    <div slot="footer" class="dialog-footer-button">
      <el-button type="primary" @click="dialogVisible = false">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getAreaCountryTree } from "@/api/seek";

export default {
  data() {
    return {
      dialogVisible: false,
      loading: false,
      row: {},
      treeData: [],
      checkedCountryIds: [],
      expandedKeys: [],
      filterText: "",
      defaultProps: {
        children: "children",
        label: "label"
      }
    };
  },
  watch: {
    filterText(val) {
      this.$refs.countryTree.filter(val);
    }
  },
  methods: {
    async init(row) {
      this.row = row;
      this.dialogVisible = true;
      this.loading = true;
      this.filterText = "";
      this.checkedCountryIds = [];
      this.expandedKeys = [];

      try {
        const treeRes = await getAreaCountryTree({ data: {} });
        if (treeRes.status == 0) {
          this.treeData = (treeRes.data || []).map(area => ({
            areaId: area.areaId,
            label: area.areaName,
            disabled: true,
            children: (area.children || []).map(country => ({
              countryId: country.countryId,
              label: country.cnName,
              disabled: true
            }))
          }));
          this.expandedKeys = this.treeData.map(item => item.areaId);
        }

        if (row.countryIds) {
          this.checkedCountryIds = row.countryIds.split(",").map(id => parseInt(id));
        }

        this.$nextTick(() => {
          setTimeout(() => {
            if (this.$refs.countryTree) {
              this.$refs.countryTree.setCheckedKeys(this.checkedCountryIds);
            }
          }, 100);
        });
      } catch (error) {
        console.error(error);
      }
      this.loading = false;
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label && data.label.indexOf(value) !== -1;
    }
  }
};
</script>

<style scoped>
::v-deep .el-tree-node.is-checked > .el-tree-node__content {
  background-color: #ecf5ff !important;
}
::v-deep .el-tree-node.is-checked > .el-tree-node__content .el-tree-node__label {
  color: #409EFF !important;
}
</style>